import script from "./payroll-additions.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-additions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__